import Vue from 'vue'
import Router from 'vue-router'
import AreaList from '@/components/AreaList'
import AreaDetail from '@/components/AreaDetail'
import AreaGroupList from '@/components/AreaGroupList'
import AreaGroupDetail from '@/components/AreaGroupDetail'
import DisasterType from '@/components/DisasterType'
import DisasterTypeDetail from '@/components/DisasterTypeDetail'
import LinkList from '@/components/LinkList'
import LinkDetail from '@/components/LinkDetail'
import PushNotification from '@/components/PushNotification'
import PushNotificationDetail from '@/components/PushNotificationDetail'
import PushNotificationTraining from '@/components/PushNotificationTraining'
import PushNotificationTrainingAdd from '@/components/PushNotificationTrainingAdd'
import PushNotificationTrainingList from '@/components/PushNotificationTrainingList'
import PushNotificationTrainingDetail from '@/components/PushNotificationTrainingDetail'
import ChargeList from '@/components/ChargeList'
import ChargeDetail from '@/components/ChargeDetail'
import MunicipalityList from '@/components/MunicipalityList'
import NotificationList from '@/components/NotificationList'
import NotificationDetail from '@/components/NotificationDetail'
import PasswordSetting from '@/components/PasswordSetting'
import Login from '@/components/Login'
import LoginAdmin from '@/components/LoginAdmin'
import PrintList from "@/components/PrintList";
import PrintDetail from "@/components/PrintDetail";
import Setting from "@/components/Setting";
import Manual from "@/components/Manual";
import PrimaryLanguage from "@/components/PrimaryLanguage"
import Contact from "@/components/Contact"
import CompanyList from '@/components/CompanyList'
import PasswordSettingCompany from '@/components/PasswordSettingCompany'
import ShelterList from '@/components/ShelterList'
import ShelterDetail from '@/components/ShelterDetail'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        savedPosition
        // if (savedPosition) {
    //         if (to.name == "pushNotification" && from.name == "pushNotificationDetail") {
    //             sessionStorage.setItem('pushPositionY', savedPosition.y)
    //         }

        //     return new Promise((resolve) => {
        //         setTimeout(() => {
        //             resolve(savedPosition)
        //         }, 500)
        //     })
        // } else {
    //         sessionStorage.setItem('pushPositionY', 0)

            return { x: 0, y: 0 }
        // }
    },
    routes: [
    {
        path: '/areaList',
        name: 'areaList',
        component: AreaList
    },
    {
        path: '/areaDetail',
        name: 'areaDetail',
        component: AreaDetail
    },
    {
        path: '/areaGroupList',
        name: 'areaGroupList',
        component: AreaGroupList
    },
    {
        path: '/areaGroupDetail',
        name: 'areaGroupDetail',
        component: AreaGroupDetail
    },
    {
        path: '/disasterType',
        name: 'disasterType',
        component: DisasterType
    },
    {
        path: '/disasterTypeDetail',
        name: 'disasterTypeDetail',
        component: DisasterTypeDetail
    },
    {
        path: '/linkList',
        name: 'linkList',
        component: LinkList
    },
    {
        path: '/linkDetail',
        name: 'linkDetail',
        component: LinkDetail
    },
    {
        path: '/pushNotification',
        name: 'pushNotification',
        component: PushNotification
    },
    {
        path: '/pushNotificationDetail',
        name: 'pushNotificationDetail',
        component: PushNotificationDetail
    },
    {
        path: '/pushNotificationTraining',
        name: 'pushNotificationTraining',
        component: PushNotificationTraining
    },
    {
        path: '/pushNotificationTrainingAdd',
        name: 'pushNotificationTrainingAdd',
        component: PushNotificationTrainingAdd
    },
    {
        path: '/pushNotificationTrainingList',
        name: 'pushNotificationTrainingList',
        component: PushNotificationTrainingList
    },
    {
        path: '/pushNotificationTrainingDetail',
        name: 'pushNotificationTrainingDetail',
        component: PushNotificationTrainingDetail
    },
    {
        path: '/chargeList',
        name: 'chargeList',
        component: ChargeList
    },
    {
        path: '/chargeDetail',
        name: 'chargeDetail',
        component: ChargeDetail
    },
    {
        path: '/municipalityList',
        name: 'municipalityList',
        component: MunicipalityList
    },
    {
        path: '/notificationList',
        name: 'notificationList',
        component: NotificationList
    },
    {
        path: '/notificationDetail',
        name: 'notificationDetail',
        component: NotificationDetail
    },
    {
        path: '/passwordSetting',
        name: 'passwordSetting',
        component: PasswordSetting
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/loginAdmin',
        name: 'loginAdmin',
        component: LoginAdmin
    },
    {
        path: '/printList',
        name: 'printList',
        component: PrintList
    },
    {
        path: '/printDetail',
        name: 'printDetail',
        component: PrintDetail
    },
    {
        path: '/setting',
        name: 'setting',
        component: Setting
    },
    {
        path: '/primaryLanguage',
        name: 'primaryLanguage',
        component: PrimaryLanguage
    },
    {
        path: '/manual',
        name: 'manual',
        component: Manual
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/companyList',
        name: 'companyList',
        component: CompanyList
    },
    {
        path: '/passwordSettingCompany',
        name: 'passwordSettingCompany',
        component: PasswordSettingCompany
    },
    {
        path: '/shelterList',
        name: 'shelterList',
        component: ShelterList
    },
    {
        path: '/shelterDetail',
        name: 'shelterDetail',
        component: ShelterDetail
    },
  ]
})